import styled, { css } from 'styled-components';
import { v2Colors, v2ReadableFontFamily } from '../../formInputsV2/styles/tokens';

export const PrivacyRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
  padding: 11px 0;
  font-family: ${v2ReadableFontFamily};
  font-size: 13px;
  line-height: 1.55;
  color: ${v2Colors.textMuted};
  cursor: pointer;

  & + & {
    border-top: 1px solid rgba(16, 24, 40, 0.07);
  }

  ${(props) => props.$hasError && css`
    background-color: ${v2Colors.dangerSoft};
    box-shadow: 0 0 0 1px ${v2Colors.danger} inset;
    border-radius: 8px;
    padding: 11px 8px;
    margin-bottom: 3px;

    & + & {
      border-top: none;
    }
  `}
`;

export const PrivacyCheckbox = styled.input`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin: 2px 0 0;
  accent-color: ${v2Colors.primary};
  cursor: pointer;
`;

export const RequiredMark = styled.span`
  color: ${v2Colors.danger};
  font-weight: 600;
`;
